<template lang="pug">
.v-field-links.field-links
	.field-links__links
		template(v-for="(option, index) in popularOptions" :key="index")
			template(v-if="index < 23")
				.field-links__link
					.field-links__link-text(@click="handleInput(option)") {{option.text}}
					.field-links__link-value {{option.count}}
		button.field-links__link(type="button" @click="open")
			.field-links__link-text {{field.label2}}
			v-svg-icon.field-links__link-icon(icon="small-chevron")
	.field-links__overlay(@click="close")
	.catalog__filter(:class="{'catalog__filter--opened': isOpened}")
		.catalog__filter-wrap.scrollbar.scrollbar--gray
			.field-links__alt-wrap
				.filter__header
					button.filter__close(type="button" @click="close")
						v-svg-icon.filter__close-icon(icon="close")
					.filter__title {{field.label2}}
				.field-links__search
					input.field-check-list__field-text-input.field-input(ref="input"
							type="text"
							:placeholder="field.placeholder || 'Найти в списке'"
							:inputmode="field.inputmode"
							:disabled="field.disabled"
							v-model="selectValueText"
							:id="uniqueId"
							@keyup="foundSelectValue")
					v-svg-icon.field-check-list__field-text-input-icon(icon="lens")
					button.field-check-list__field-text-clean(v-if="selectValueText"
							type="button"
							@click="cleanSelectText")
						v-svg-icon.field-check-list__field-text-clean-icon(icon="close")
				.field-links__links-alt
					template(v-for="(option, index) in field.options" :key="index")
						template(v-if="isFoundSelectText(option.text)")
							.field-links__link-alt(@click="close(); handleInput(option);")
								.field-links__link-alt-text {{option.text}}
								.field-links__link-value {{option.note}}
					.field-links__empty-text Ничего не найдено
</template>

<script>
import controller from "../scripts/controller/controller.js";
import uniqueId from "../scripts/helpers/uniqueId.js";

export default {
	emits: [
		'update:model-value',
	],

	props: {
		field: {
			type: Object,
			default: null
		},

		modelValue: {
			type: [Object, String, Number, Boolean, Symbol, Date],
			default: null
		}
	},

	data() {
		return {
			localValue: null,
			isOpened: false,
			uniqueId: uniqueId('field-'),
			selectValueText: '',
			isSelectValueFound: false,
			selectValue: null
		}
	},

	watch: {
		modelValue: {
			immediate: true,
			handler() {
				this.updateLocalValue();
			}
		}
	},

	computed: {
		popularOptions() {
			return this.field.options.filter(item => item.popular === true);
		}
	},

	methods: {
		foundSelectValue() {
			let result = false;
			if (this.field && this.field.options && this.field.options.length) {
				for (let i = 0; i < this.field.options.length; i++) {
					if (this.isFoundSelectText(this.field.options[i].text)) {
						result = this.field.options[i].text;
						this.isSelectValueFound = true;
						break;
					}
				}
				if (result) {
					this.isSelectValueFound = true;
				} else {
					this.isSelectValueFound = false;
				}
			}
			return result;
		},

		isFoundSelectText(text = '') {
			if (this.field.searchAjax) {
				return true;
			}
			let result = false;
			let selectValueText = this.selectValueText;
			if (!selectValueText) {
				selectValueText = '';
			}
			if (text.toLowerCase().indexOf(selectValueText.toLowerCase()) !== -1) {
				result = true;
			} else {
				result = false;
			}
			return result;
		},

		cleanSelectText() {
			this.selectValueText = '';
		},

		open() {
			document.body.classList.add('state--field-links-open');
			this.isOpened = true;
			controller.lockScrolling(document.querySelectorAll('.catalog__filter-wrap'));
		},

		close() {
			document.body.classList.remove('state--field-links-open');
			this.isOpened = false;
			controller.unlockScrolling(document.querySelectorAll('.catalog__filter-wrap'));
		},

		reset() {
			this.localValue = null;
		},

		updateLocalValue() {
			this.localValue = this.modelValue;
		},

		handleInput(option) {
			console.log('option', option)
			this.localValue = option.value;
			this.$emit('update:model-value', this.localValue);
			this.updateLocalValue();
		}
	}
}
</script>